'use es6';

import Immutable from 'immutable';
import ActionTypes from '../constants/ActionTypes';
import RequestStatusTypes from '../constants/RequestStatusTypes';
var defaultState = Immutable.Map({
  goodToUninstall: {},
  open: false,
  uninstallRequestError: null,
  uninstallRequestStatus: RequestStatusTypes.UNINITIALIZED
});
export default function uninstallConfirmModalReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ActionTypes.SHOW_UNINSTALL_CONFIRM_MODAL:
      return state.merge({
        goodToUninstall: action.payload,
        open: true
      });

    case ActionTypes.UNINSTALL_GOOD:
      if (action.error) {
        return state.merge({
          uninstallRequestError: action.payload,
          uninstallRequestStatus: RequestStatusTypes.FAILED
        });
      }

      return state.set('uninstallRequestStatus', RequestStatusTypes.PENDING);

    case ActionTypes.DISMISSED_UNINSTALL_CONFIRM_MODAL:
    case ActionTypes.PURCHASED_GOODS_RECEIVED:
      return defaultState;

    default:
      return state;
  }
}